module.exports = __webpack_public_path__ + "img/visa.4eb0a66d.png";